import { combineReducers } from 'redux';
import { questionnaireTemplateReducer } from './questionnaireTemplate.reducer';
import { questionnaireTemplateDetailsReducer } from './questionnaireTemplateDetails.reducer';
import { questionnaireDetailsReducer } from './questionnaireDetails.reducer';

export const questionnaireStore = combineReducers({
    questionnaireDetails:questionnaireDetailsReducer,
    questionnaireTemplate : questionnaireTemplateReducer,
    questionnaireTemplateDetails : questionnaireTemplateDetailsReducer,
});
